import styled from "styled-components";
import { Link } from "react-router-dom";

export const HomeButton = styled(Link)`
  width: 20rem;
  height: 3rem;
  border-radius: 35px;
  display: block;
  text-align: center;
  line-height: 3rem;
  margin-top: 2rem;
  text-decoration: none;
  border: 2px solid #d3d3d3;
  cursor: pointer;
  transition: linear 0.4s;
  font-weight: 600;
  background: transparent;
  backdrop-filter: blur(4px);
  color: #d3d3d3;
  &:hover {
    background: #d3d3d3;
    background-blend-mode: normal;
    color: #141414;
  }
`;

export const MenuButton = styled.div`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: linear 0.4s;
  font-weight: 600;
  background: #fff;
  backdrop-filter: blur(4px);
  color: #262626;
  font-size: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LinkButton = styled(Link)`
  width: 45px;
  height: 45px;
  border-radius: 45px;
  display: block;
  text-align: center;
  line-height: 45px;
  margin-top: 2rem;
  text-decoration: none;
  border: 2px solid #d3d3d3;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
  transition: linear 0.4s;
  font-weight: 600;
  background: transparent;
  backdrop-filter: blur(4px);
  color: #d3d3d3;
  overflow: hidden;
`;

export const BlockButton = styled.div`
  width: 100%;
  height: 40px;
  gap: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NextButton = styled(Link)`
  width: 40px;
  height: 40px;
  border-radius: 40px;
  border: none;
  cursor: pointer;
  transition: linear 0.4s;
  font-weight: 600;
  background: #141414;
  color: #fff;
  font-size: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #141414;
  transition: linear 0.4s;
  text-decoration: none;
  &:hover {
    color: #141414;
    background-color: transparent;
  }
`;
